
function isValidMobile(value) {
  if (value === '' || value === null || value === undefined) {
    return false;
  }
  const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
  if (!reg.test(value)) {
    return false;
  }
  return true;
}
function isValidTelephone(value) {
  if (value === '' || value === null || value === undefined) {
    return false;
  }
  const reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
  const reg2 = /^([0-9]{3,4})?[0-9]{7,8}$/;
  if (!reg.test(value) && !reg2.test(value)) {
    return false;
  }
  return true;
}
function isValidInt(value) {
  if (value === '' || value === null || value === undefined) {
    return false;
  }
  const reg = /^[0-9]*$/;
  if (!reg.test(value)) {
    return false;
  }
  return true;
}

module.exports = {
  isValidMobile,
  isValidTelephone,
  isValidInt
};
